import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { env } from '../../environments/environment';
import { Answer, AnswerChange } from '../shared/interfaces';
import { AnswerStatus } from './answer.status';

@Injectable({
  providedIn: 'root',
})
export class AnswerService {
  constructor(protected http: HttpClient) {}

  get(id: number) {
    return this.http.get<Answer>(`${env.APIUrl}/answer/${id}`).toPromise();
  }

  setStatus(id: number, status: AnswerStatus) {
    return this.http.patch<any>(`${env.APIUrl}/answer/${id}`, { status }).toPromise();
  }

  addFlag(id: number, flag: object) {
    return this.http.post<any>(`${env.APIUrl}/answer/${id}/flag`, flag).toPromise();
  }

  getChanges(answerId: number) {
    return this.http.get<AnswerChange[]>(`${env.APIUrl}/answer/${answerId}/changes`).toPromise();
  }

  editFlag(id: number, index: number, flag: object) {
    return this.http.put<any>(`${env.APIUrl}/answer/${id}/flag/${index}`, flag).toPromise();
  }

  removeFlag(id: number, index: number) {
    return this.http.delete<any>(`${env.APIUrl}/answer/${id}/flag/${index}`).toPromise();
  }

  addComment(id: number, flag: object) {
    return this.http.post<any>(`${env.APIUrl}/answer/${id}/comment`, flag).toPromise();
  }

  removeComment(id: number, index: number) {
    return this.http.delete<any>(`${env.APIUrl}/answer/${id}/comment/${index}`).toPromise();
  }

  changeAnswer(id: number, answer: string) {
    return this.http.put<any>(`${env.APIUrl}/answer/${id}`, { answer }).toPromise();
  }

  remove(id: number) {
    return this.http.delete<any>(`${env.APIUrl}/answer/${id}`).toPromise();
  }

  add(answer) {
    return this.http.post<any>(`${env.APIUrl}/answer`, answer).toPromise();
  }

  bulkEditStatus(answerIds: number[], status: number) {
    return this.http.put<any>(`${env.APIUrl}/answer`, { answerIds, status }).toPromise();
  }

  async addPicture(answer: Answer, file: File & { progress: number }): Promise<any> {
    const formData: FormData = new FormData();
    formData.append('upload', file, file.name);

    const request = this.http
      .post<any>(`${env.APIUrl}/answer/${answer.id}/picture`, formData, { reportProgress: true, observe: 'events' })
      .pipe(
        map(event => {
          if (event.type === HttpEventType.UploadProgress) {
            const percentDone = Math.round((100 * event.loaded) / event.total);
            file.progress = percentDone;
          }
        }),
        catchError((error: any) => {
          console.error('An error occurred:', error);
          return Observable.throw(error.message || error);
        }),
      );

    await request.toPromise();
    return this.get(answer.id);
  }
}
